module.exports = __webpack_public_path__ + "static/media/14-audio.1a0058c6.png";